import React from 'react';
import 'air-datepicker/dist/js/datepicker';
import 'air-datepicker/dist/js/i18n/datepicker.en';
import 'assets/stylesheets/datepicker.css';


export default class Airpicker extends React.Component {
  componentDidMount(){
    this.initDatepicker();
  }
  
  initDatepicker(){
    $(this.refs.datepicker).datepicker(this.props);
  }

  render(){
    return (
      <div ref='datepicker' className="mt-6" id="#calendar-doctor" data-language='en'></div>
    )
  }
}